var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavicon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 6,
    fill: "#DC3545"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.4436 11V14.5789H26.8271V26.0827H36.797C37.1038 26.0827 37.6491 26.1168 38.4331 26.185C39.217 26.219 40.0521 26.3043 40.9383 26.4406C41.8246 26.5429 42.5915 26.7133 43.2391 26.9519C43.8867 27.1905 44.2105 27.4972 44.2105 27.8722V43.2105C44.2105 43.5855 43.8867 43.8922 43.2391 44.1308C42.5915 44.3694 41.8246 44.5569 40.9383 44.6932C40.0521 44.7955 39.217 44.8807 38.4331 44.9489C37.6491 44.983 37.1038 45 36.797 45H12.2556V41.4211H29.3835V29.6617H19.4135C19.1068 29.6617 18.5614 29.6446 17.7774 29.6105C16.9935 29.5424 16.1584 29.4571 15.2722 29.3549C14.386 29.2185 13.619 29.0311 12.9714 28.7925C12.3238 28.5539 12 28.2471 12 27.8722V12.7895C12 12.4145 12.3238 12.1078 12.9714 11.8692C13.619 11.6306 14.386 11.4601 15.2722 11.3579C16.1584 11.2216 16.9935 11.1363 17.7774 11.1023C18.5614 11.0341 19.1068 11 19.4135 11H43.4436Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/Favicon.d655a5c49627c0a04bdf3171185ee6a0.svg";
export { ForwardRef as ReactComponent };